export default class t{constructor(t,s){this.S=!!t,this.ve=s||[]}V(t){this.S=this.S&&t.S,this.ve.push(...t.ve)}}